/**
 * Implements a CR chart edit screen.
 */

import Marionette from "backbone.marionette";
import Layout from "./layout";
import mix from "../../../utils/mixin-builder";
import ModalMixin from "../../../mixins/modal";

const TITLE = "Chart Review";

const DEFAULTS = {
  title: TITLE,
  view: Layout,
};

class View extends mix(Marionette.LayoutView).with(ModalMixin) {
  constructor(options = {}) {
    _.defaults(options, DEFAULTS);
    super(options);
  }

  el() {
    // use tabbed template, which allows for one form per tab, if needed.
    return "#chart-review-tabbed-modal";
  }

  childEvents() {
    return {
      "modal:close": "_hide",
    };
  }

  initialize() {
    // implementation here

    // make sure to execute the mixin's initialize method
    if (super.initialize) super.initialize();
  }

  _hide() {
    // handle actual modal dismiss
    this.hide();
  }
}

export { View as default };
